import { mdiDotsHorizontal } from '@mdi/js'
import Icon from '@mdi/react'

const DotMenu = (props) => (
    <Icon
        data-testid="IconButton__DotMenu"
        aria-label="Model Menu"
        path={mdiDotsHorizontal}
        size={1}
        {...props}
    />
)

export default DotMenu
